import React, { useState } from 'react';
import { withRouter, Link } from 'react-router-dom';
import axios from 'axios';
import Snackbar from '@material-ui/core/Snackbar';
import { Alert, Form, FormControl } from 'react-bootstrap';
import _get from 'lodash/get';
import { setAxiosAuthToken } from '../../utils/Utils';
import Header from '../header/Header';
import { FormWrapper, Label } from '../../styles/LoginStyles';
import {
  Wrapper,
  Container,
  HomeButtons,
  SignupButton
} from '../../styles/HomeStyles';
import { config } from '../../config';
import { Toast } from '../student/Home';

export default function Signup() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [confirmpassword, setconfirmPassword] = useState('');
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [usernameError, setUsernameError] = useState('');
  const [phoneError, setPhoneError] = useState('');
  const [emailError, setEmailError] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [confirmPasswordError, setConfirmPasswordError] = useState('');
  const [nameError, setnameError] = useState('');
  const [status, setStatus] = useState('');
  const [registerSuccess, setRegisterSuccess] = useState(false);
  const [usertype, setUserType] = useState(0);
  const [alertSuccess, setAlertSuccess] = useState(false);
  const [alertFailure, setAlertFailure] = useState(false);

  const onSignupClick = () => {
    setUsernameError('');
    setPasswordError('');
    setConfirmPasswordError('');
    setEmailError('');
    setnameError('');
    let userData = {};

    if (phone === '') {
      userData = {
        password,
        email,
        name,
        usertype
      };
    } else {
      userData = {
        password,
        email,
        phone,
        name,
        usertype
      };
    }

    // if (username === '') {
    //   setUsernameError('Username cannot be empty');
    // }
    const mailregex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneregex = /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/im;

    console.log(userData, 'userData', password);

    if (password === '') {
      setPasswordError('Password cannot be empty');
    } else if (email === '') {
      setEmailError('Email cannot be empty');
    } else if (!email.match(mailregex)) {
      setEmailError('Please enter a valid email format');
    } else if (name === '') {
      setnameError('Name cannot be empty');
    } else if (password !== confirmpassword) {
      setConfirmPasswordError("Passwords don't match");
    } else if (phone) {
      const phoneno = /^\d{10}$/;
      if (!phone.match(phoneno)) {
        setPhoneError('Please enter a valid phone number.');
      }
    } else if (usertype === 0) {
      setStatus('Please select an user type');
      setAlertFailure(true);
    } else {
      axios
        .post(`${config.API_URL}user/auth/register/`, userData)
        .then(response => {
          setRegisterSuccess(true);
          setStatus(
            'Congratulations! Your account is set up! Please verify your email!'
          );
          setAlertSuccess(true);
        })
        .catch(error => {
          setStatus('There was a problem during account creation');
          setAlertFailure(true);
        });
    }
  };
  // const errorAlert = (
  //   <Alert variant="danger">
  //     <Alert.Heading>Problem during account creation</Alert.Heading>
  //     Please try again.
  //   </Alert>
  // );

  // const successAlert = (
  //   <Alert variant="success">
  //     <Alert.Heading>Account created</Alert.Heading>
  //     {/* <p>
  //         We send you an email with activation link. Please check your email.
  //       </p> */}
  //     <p>Congratulations! Your account is set up! Please verify your email!</p>
  //   </Alert>
  // );

  const form = (
    <div>
      <Form style={{ textAlign: 'center' }}>
        <Form.Group controlId="emailId">
          <Label>Email</Label>
          <Form.Control
            isInvalid={emailError}
            type="text"
            name="email"
            placeholder="Enter email"
            value={email}
            onKeyPress={event => {
              if (event.key === 'Enter') {
                onSignupClick();
              }
            }}
            onChange={e => setEmail(e.currentTarget.value)}
          />
          <FormControl.Feedback type="invalid">
            {emailError}
          </FormControl.Feedback>
        </Form.Group>

        <Form.Group controlId="name">
          <Label>Name</Label>
          <Form.Control
            isInvalid={nameError}
            type="text"
            name="name"
            placeholder="Enter Name"
            value={name}
            onKeyPress={event => {
              if (event.key === 'Enter') {
                onSignupClick();
              }
            }}
            onChange={e => setName(e.currentTarget.value)}
          />
          <FormControl.Feedback type="invalid">
            {nameError}
          </FormControl.Feedback>
        </Form.Group>

        <Form.Group controlId="phone">
          <Label>Phone (Optional)</Label>
          <Form.Control
            isInvalid={phoneError}
            type="text"
            name="email"
            placeholder="Enter phone number"
            value={phone}
            onKeyPress={event => {
              if (event.key === 'Enter') {
                onSignupClick();
              }
            }}
            onChange={e => setPhone(e.currentTarget.value)}
          />
          <FormControl.Feedback type="invalid">
            {phoneError}
          </FormControl.Feedback>
        </Form.Group>

        <Form.Group controlId="passwordId">
          <Label>Password</Label>
          <Form.Control
            isInvalid={passwordError}
            type="password"
            name="password"
            placeholder="Enter password"
            value={password}
            onKeyPress={event => {
              if (event.key === 'Enter') {
                onSignupClick();
              }
            }}
            onChange={e => setPassword(e.currentTarget.value)}
          />
          <Form.Control.Feedback type="invalid">
            {passwordError}
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group controlId="confirmpasswordId">
          <Label>Confirm Password</Label>
          <Form.Control
            isInvalid={confirmPasswordError}
            type="password"
            name="password"
            placeholder="Re-enter password"
            value={confirmpassword}
            onKeyPress={event => {
              if (event.key === 'Enter') {
                onSignupClick();
              }
            }}
            onChange={e => setconfirmPassword(e.currentTarget.value)}
          />
          <Form.Control.Feedback type="invalid">
            {confirmPasswordError}
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group>
          <label style={{ marginRight: 10 }}>
            <input
              type="radio"
              id="radio1"
              name="radio1"
              value="3"
              onClick={() => setUserType(4)}
              style={{ marginRight: 5 }}
            />
            Student
          </label>
          <label>
            <input
              type="radio"
              id="radio1"
              name="radio1"
              value="4"
              onClick={() => setUserType(3)}
              style={{ marginRight: 5 }}
            />
            Instructor
          </label>
        </Form.Group>
      </Form>
      <center>
        <HomeButtons color="primary" onClick={() => onSignupClick()}>
          Sign up
        </HomeButtons>
      </center>
    </div>
  );

  // let alert = '';
  // if (status === 'error') {
  //   alert = errorAlert;
  // } else if (status === 'success') {
  //   alert = successAlert;
  // }

  const handleClose = (event, reasons) => {
    if (reasons === 'clickaway') {
      return;
    }
    setAlertFailure(false);
    setAlertSuccess(false);
  };

  return (
    <Container>
      <Header isHome={true} center={true} />
      <Snackbar
        open={alertFailure}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Toast onClose={handleClose} severity="error">
          {status}
        </Toast>
      </Snackbar>
      <Snackbar
        open={alertSuccess}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Toast onClose={handleClose} severity="success">
          {status}
        </Toast>
      </Snackbar>
      <Wrapper>
        <FormWrapper>
          {!registerSuccess && form}
          {registerSuccess && (
            <h2>
              Signup Successful, Please confirm your email by checking your
              inbox!
            </h2>
          )}
          <Label>
            Already have account? <Link to="/login">Login</Link>
          </Label>
        </FormWrapper>
      </Wrapper>
    </Container>
  );
}
